import React, { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconPrefix, IconName } from '@fortawesome/fontawesome-common-types'
import { sortType } from '../../../states/types/common'

interface SortBlockProps {
  label: string
  type: string
  currentSortType: { key: string, type: 'desc' | 'asc' }
  onSortChange: (sortType: { key: string, type: 'desc' | 'asc' }) => void
}

const SortBlock: FC<SortBlockProps> = ({
  label,
  type,
  currentSortType,
  onSortChange
}) => {
  const getSortState = (): 'none' | 'desc' | 'asc' => {
    if (currentSortType.key !== type) return 'none'
    return currentSortType.type
  }

  const handleClick = () => {
    const state = getSortState()
    switch (state) {
      case 'none':
        onSortChange({ key: type, type: 'desc' })
        break
      case 'desc':
        onSortChange({ key: type, type: 'asc' })
        break
      case 'asc':
        onSortChange({ key: type, type: 'desc' })
        break
    }
  }

  const getSortIcon = (): [IconPrefix, IconName] => {
    const state = getSortState()
    switch (state) {
      case 'desc':
        return ['fas', 'sort-amount-down']
      case 'asc':
        return ['fas', 'sort-amount-down-alt']
      default:
        return ['fas', 'sort']
    }
  }

  return (
    <div
      className="sort_block"
      onClick={handleClick}
      role="none"
    >
      {label}
      <span className="sort_button">
        <FontAwesomeIcon icon={getSortIcon()} />
      </span>
    </div>
  )
}

export default SortBlock